import React, { useEffect, useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import checkImage from "../../assests/images/check-circle.png";
import { rfqServices } from "../../services/rfqServices";
import Switch from "@mui/material/Switch";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LayersIcon from "@mui/icons-material/Layers";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AlertComponent from "../alert/alert";
import _ from "lodash";
import Filter from "../filter/filter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Backdrop, CircularProgress } from "@mui/material";
import { getSecPermission, urlConstants, strToDate, isEmptyDash, trimString } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import { UserObj } from "../../services/localStarage";
import axios from "axios";
import ConfirmModal from "../common/rfqConfirmModal";
import { DatePicker, Space } from 'antd';
import RfqExtendValidaity from "../common/rfqExtendValidaityModal";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { usePreviousLocation } from "../../components/withSidebar/PreviousLocationContext";
import { Editor } from "react-draft-wysiwyg";
import NfaApprovalModal from "../common/nfaApprovalModal";
import CustomSearchDropdown from "../common/customSearchDropdown";
import { projectServices } from "../../services/projectServices"; 
import PersonIcon from "@mui/icons-material/Person";  
import ExitingVendor from "../common/rfqExitingVendorModal"; 
import { downloadFile } from "../buyerPurchaseOrder/index.js";
import DownloadIcon from '@mui/icons-material/Download';

const initialColumns = [
  { id: "rfqNumber", label: "RFQ Number", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectName", label: "Project Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "packageName", label: "Package Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "invitationDate", label: "RFQ invitation date", isSort: true, sortLabel: "", isFiltered: false },
  { id: "lastUpdatedOn", label: "Last Updated", isSort: true, sortLabel: "", isFiltered: false },

  // { id: "description", label: "Description", isSort: true, sortLabel: "", isFiltered: false },
  { id: "qty", label: "Qty", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectCode", label: "Project Code", isSort: true, sortLabel: "", isFiltered: false },
  { id: "packageCode", label: "Package Code", isSort: true, sortLabel: "", isFiltered: false },
  { id: "rfqType", label: "Bid Type", isSort: true, sortLabel: "", isFiltered: false },
  { id: "bidMode", label: "Bid Mode", isSort: true, sortLabel: "", isFiltered: false },
  { id: "nfa", label: "NFA", isSort: true, sortLabel: "", isFiltered: false },
  { id: "vendorsInvited", label: "Invited Vendors", isSort: true, sortLabel: "", isFiltered: false },
  { id: "vendorsResponded", label: "Responded Vendors", isSort: true, sortLabel: "", isFiltered: false },
  { id: "technicalEvaluationStatus", label: "Technical Evaluation Status", isSort: true, sortLabel: "", isFiltered: false },
  { id: "commercialEvaluationStatus", label: "Commercial Evaluation Status Round 1", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "commercialEvaluationStatusRound2", label: "Commercial Evaluation Status Round 2", isSort: true, sortLabel: "" },
  { id: "finalStatus", label: "Final Status", isSort: true, sortLabel: "", isFiltered: false },
  { id: "rfqValidity.from", label: "RFQ Validity From Date", isSort: true, sortLabel: "", isFiltered: false },
  { id: "rfqValidity.to", label: "RFQ Validity To Date", isSort: true, sortLabel: "", isFiltered: false },
 
  { id: "participationStatus", label: "Participation status", isSort: true, sortLabel: "", isFiltered: false },
  { id: "createdAt", label: "created on", isSort: true, sortLabel: "", isFiltered: false },
  { id: "createdBy", label: "Created by", isSort: true, sortLabel: "", isFiltered: false },

];
const statusArr = ["Initiated", "Drafted", "Created", "Approved", "Rejected", "Hold", "Published", "Technical_Evaluation_In_Progress", "Technical_Evaluation_Done", "Commercial_Evaluation_In_Progress", "Round_1_Completed", "Round_2_Initiated", "Round_2_Published", "Round_2_Completed"];
const finalStatus = ["Round 1 Completed","Round 2 Completed"];
const initialColumnsApprove = [
  { id: "Sr.no.", label: "Sr. No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorsname", label: "Vendor’s Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorstatus.", label: "Vendor Status", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "quotationreceived", label: "Quotation Received", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "technicallyacceptable", label: "Technically Acceptable", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];
const { RangePicker } = DatePicker;

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const nfastyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const userRole = UserObj?.role?.name;

if (userRole !== "VENDOR") {
  const columnsToRemove = ["invitationDate", "participationStatus"];
  // Mutating the array directly without reassigning
  initialColumns.splice(
    0,
    initialColumns.length,
    ...initialColumns.filter(column => !columnsToRemove.includes(column.id))
  );
}

if (userRole == "VENDOR") {
  initialColumns.splice(5, 10);
}
if (userRole !== "VENDOR") {
  initialColumns.splice(19);
}

const permissionInit = {
  "create": false,
  "read": false,
  "update": false,
  "delete": false
};

function ListingRFQ() {
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [rfqlisting, setRfqListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    rfqs: [],
  });
  const [secRFQPermission, setSecRFQPermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });


  const [secRFQListPermission, setSecRFQListPermission] = useState({
    "CREATE_RFQ": permissionInit,
    "ROUND_2_COMPARISON": permissionInit,
    "INITIATE_ROUND_2": permissionInit,
    "EXTEND_VALIDITY": permissionInit,
    "PUBLISH_RFQ": permissionInit,
    "REJECT": permissionInit,
    "HOLD": permissionInit,
    "APPROVE": permissionInit,
    "DOWNLOAD_RFQ": permissionInit,
    "CLOSE_RFQ": permissionInit,
    "PARTICIPATE": permissionInit,
    "RFQ_LISTING": permissionInit,
  });

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };


  const previousLocation = usePreviousLocation();

  const [columns, setColumns] = useState(initialColumns);
  const [approvecolumns, setApproveColumns] = useState(initialColumnsApprove);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const [opencreatenewrfq, setOpenCreateNewRfq] = useState(false);
  const [opnextendvalidtymodal, setOpnExtendValidtyModal] = useState(false);
  const [openextendrfqvalidtyyesmodal, setOpenExtendRfqValidtyYesModal] =
    useState(false);
  const [opencreaterfqnewtoggler, setOpenCreateRfqnewToggler] =
    useState("AgainstPackage");
  const [openvalidtyextendsuccessfully, setOpenValidtyExtendSuccessfully] =
    useState(false);
  const [openapproverfqpublishmodal, setOpenApproveRfqPublishModal] =
    useState(false);
    const [opennfaapprovelmodal, setOpenNfaApprovelModal] =
    useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [packagecodesrequested, setPackageCodesRequested] = useState("");
  const [rfqType, setRfqType] = useState("TWO_BID");
  const [ApprovalFlow, setApprovalFlow] = useState("Linear");
  const [filterFormData, setFilterFormData] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [status, setStatus] = useState('');
  const [rfqNumber, setRfqNumber] = useState('');
  const [currentRfqValidity, setCurrentRfqValidity] = useState({
    from: "",
    to: ""
  });
  const [currentValidityPeriod, setCurrentValidityPeriod] = useState("");
  const [newRfqValidity, setNewRfqValidity] = useState({ from: "", to: "" });
  const [newValidityPeriod, setNewValidityPeriod] = useState("");
  const [engineerAssignee, setEngineerAssignee] = useState('');
  const [engineerAssigneeValue, setEngineerAssigneeValue] = useState('');
  const [inputPage, setInputPage] = useState(rfqlisting?.currentPage || 1);
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= rfqlisting?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(rfqlisting?.currentPage);
      }
    }
  };
  const handleRfqTypeChange = (event) => {
    setRfqType(event.target.checked ? "TWO_BID" : "ONE_BID");
  };
  const handleRfqApprovalFlow = (event) => {
    setApprovalFlow(event.target.checked ? "Simultaneous" : "Linear");
  }
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClosess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }
  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );
  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getRfqListing(requestPayload, filterText);
  };




  useEffect(() => {
    let permissionObj2 = getSecPermission("RFQ_LISTING");
    setSecRFQPermission(permissionObj2);

    let secRFQListPermissionInit = _.cloneDeep(secRFQListPermission);
    let obj = {};
    for (let key in secRFQListPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecRFQListPermission(obj);
    if (previousLocation?.pathname?.includes("/admin/Buyer-Bidding-Rfq-Creaction-Form")) {
      const UserObjInit = JSON.parse(sessionStorage.getItem('user'));

      if ( UserObjInit?.prevLocationData && UserObjInit.prevLocationData.componentName == "RFQ_LIST") {
        setFilterText(UserObjInit.prevLocationData?.filterText);
        setRequestPayload(UserObjInit.prevLocationData?.requestPayload);
        setFilterFormData(UserObjInit.prevLocationData?.filterFormData);
      } 
    }
  }, []);

  // useEffect(() => {
  //   getRfqListing(requestPayload, filterText, filterFormData);
  // }, [requestPayload]);
  useEffect(() => {
    getRfqListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const getRfqListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = "";
    if (userRole == "VENDOR") {
      promise = rfqServices.getVendorRfqListing(param);
    } else {
      promise = rfqServices.getRfqListing(param);
    }

    // rfqServices
    //   .getRfqListing(param)
    promise.then((res) => {
      // throw errors
      if (res.data.success === true) {
        setRfqListing(res.data.data);
      } else {
        setAlertComponent({
          open: true,
          type: "error",
          message: `No Data Found `,
        });
      }
    })

      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const [selectedProjectCode, setSelectedProjectCode] = useState(null);
  const [showRejctModal, setShowRejectModal] = useState(false);
  const [showExtendVendor, setShowExtendVendor] = useState(false);
  const onSearchSelectChange = (param) => {
    setSelectedProjectCode(param);
  }
  const submitRFQ = () => { 
    setIsLoading(true);
    let bodydata = {};
    if (opencreaterfqnewtoggler === "AgainstPackage") {
      bodydata = {
        "againstPackage": true,
        "packageCode": packagecodesrequested,
        rfqType,
      }
    }
    else if (opencreaterfqnewtoggler === "WithoutPackage") {
      if ((!engineerAssigneeValue || engineerAssigneeValue.trim() === '') && rfqType === 'TWO_BID') {
        setAlertComponent({ open: true, type: "error", message: "Please Select Assign Engineer" });
        setIsLoading(false);
        return;
      }
      bodydata = {
        "againstPackage": false,
        rfqType,
        "engineerAssignee": engineerAssigneeValue,
        "projectId" : selectedProjectCode?.selectedValue
      }
    }
    if (rfqType === 'TWO_BID') {
      bodydata.approvalFlow = ApprovalFlow;
    }

    rfqServices.createNewRfq(bodydata)
      .then((res) => {
        // throw errors
        if (res.data.success === true) {
          // setRfqListing(res.data.data);
          setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
          navigateUrl(`/admin/Buyer-Bidding-Rfq-Creaction-Form/${res.data.data?._id}`);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        }
      })

      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getRfqListing(updatedPayload, filterText, formDataa || '');
    const updatedColumns = columns.map((col) => {
      const isFiltered = Object.keys(formDataa).includes(col.id);
      return { ...col, isFiltered };
    });
    setColumns(updatedColumns);
    const filters = Object.keys(formDataa).map((key) => {
      if (key.endsWith('_from_date') || key.endsWith('_to_date')) {
        const fieldBaseName = key.replace('_from_date', '').replace('_to_date', '');
        return `${fieldBaseName}: ${formDataa[key.replace('_from_date', '') + '_from_date'] || ''} to ${formDataa[key.replace('_from_date', '') + '_to_date'] || ''}`;
      }
      // return `${key}: ${formDataa[key]}`;
      return `${key}:${formDataa[key]}`;
    });
    setActiveFilters(filters);
  };

  const handleResetFormSubmit = () => {
    getRfqListing(requestPayload, filterText, {});
    const resetColumn = columns.map(col => ({
      ...col, isFiltered: false,
    }))
    setColumns(resetColumn);
    setActiveFilters([]);
    setFilterFormData({});
  }
  const downloadRfqDoc = () => {
    setIsLoading(true);
    let rfqId = selectedRows[0]?._id;
    if (rfqId) {
      axios({
        method: 'POST',
        url: `${urlConstants.BASE_URI_DEV}/v1/internal/rfqs/download-documents`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${UserObj?.accessToken}`
        },
        data: JSON.stringify({ rfqId: rfqId }),
        responseType: 'blob'
      })
        .then((res) => {
          if (res && res.data) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'rfq-document.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            setAlertComponent({
              open: true,
              type: 'error',
              message: "Unauthorized: Not Enough Access to perform this action",
            });
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: `${error?.response?.data?.message}`,
            });
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setAlertComponent({
        open: true,
        type: 'error',
        message: 'Please Select Rfq Number first',
      });
      setIsLoading(false);
    }
  }


  useEffect(() => {
    calculateDateDifference();
  }, [currentRfqValidity]);


  const handleCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedRows(prev => [...prev, row]);
    } else {
      setSelectedRows(prev => prev.filter(selectedRow => selectedRow._id !== row._id));
    }
  };
  const isChecked = (rowId) => selectedRows.some(selectedRow => selectedRow._id === rowId);
  const redirectToDetails = (redirectId) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: "RFQ_LIST",
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(`/admin/Buyer-Bidding-Rfq-Creaction-Form/${redirectId}`);
  };


  const changeStatusConfirmation = (status) => {  
    if (selectedRows.length > 1) {
      setAlertComponent({
        open: true,
        type: 'error',
        message: 'Please select only one RFQ at a time.',
      });
      setIsLoading(false);
      return;  
    }
    let reqId = selectedRows[0]?._id;
    const rfqNumber = selectedRows[0]?.rfqNumber;
    const finalStat = selectedRows[0]?.finalStatus;
    const nfaId = selectedRows[0]?.nfaId;
    if (!reqId) {
      setAlertComponent({
        open: true,
        type: 'error',
        message: 'Please Select Rfq Number first',
      });
      setIsLoading(false);
    }else if(status === 'request_approval'){  
      if(!isEmptyDash(nfaId)){
        setAlertComponent({
          open: true,
          type: 'error',
          message: 'You Already request for Approval',
        });
      }else if (finalStatus.indexOf(finalStat) >= 0){
          setOpenNfaApprovelModal(true);
        }else{
          setAlertComponent({
            open: true,
            type: 'error',
            message: 'You can not request for Approval',
          });
        } 
    }else  if(status === 'Extend_vendor'){
      setShowExtendVendor(true);
    } else if (rfqNumber.startsWith('TEMP') && status === 'Cancel') {
      setAlertComponent({
        open: true,
        type: 'error',
        message: 'Closing Temporary RFQ is not allowed',
      });
      setIsLoading(false);
    } else {
      if (status === 'Extend') {
        const fromDateString = selectedRows[0]?.rfqValidity?.from;
        const toDateString = selectedRows[0]?.rfqValidity?.to;
  
        // Validate dates
        if (!fromDateString || !toDateString || isNaN(new Date(fromDateString)) || isNaN(new Date(toDateString))) {
          setAlertComponent({
            open: true,
            type: 'error',
            message: 'Invalid RFQ validity dates.',
          });
          setIsLoading(false);
          return;
        }

        setRfqNumber(selectedRows[0]?.rfqNumber);
        // const dateString = selectedRows[0]?.rfqValidity?.from;
        const date = new Date(fromDateString);
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 1);
        const fromDate = date.toISOString().split('T')[0];

        // const datetoString = selectedRows[0]?.rfqValidity?.to;
        const toDate = new Date(toDateString);
        toDate.setHours(0, 0, 0, 0);
        toDate.setDate(toDate.getDate() + 1);
        const toDDate = toDate.toISOString().split('T')[0];
  

        setCurrentRfqValidity({
          from: fromDate,
          to: toDDate
        })
        setOpnExtendValidtyModal(true);
      } else {
        setStatus(status);
        setIsConfirmModalOpen(true);
      }

    }

  }


  const successConfirmModal = () => {
    setIsLoading(true);
    let bodydata = {
      "status": status,
    }
    if (selectedRows[0].finalStatus === "Round 2 Initiated") {
      bodydata["round"] = 2
    }
    let reqId = selectedRows[0]?._id;
    if (reqId) {
      if (userRole === "VENDOR") {
        let idArr = selectedRows.map(ele => ele?._id);
        let obj = {
          "rfqIds": idArr,
          "action": status,
        };
        rfqServices.vendorRfqTakeAction(obj)
          .then((res) => {
            if (res && res.data) {
              if (status === 'Participate') {
                navigateUrl(`/admin/Buyer-Bidding-Rfq-Creaction-Form/${reqId}`);
              }
              if(status === 'Reject'){
                setShowRejectModal(true);
              }
              setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
              setIsConfirmModalOpen(false);
            } else {
              setAlertComponent({ open: true, type: "error", message: `No Data Found` });
            }
          })
          .catch((error) => {
            setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
            setIsConfirmModalOpen(false);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
      else {
        rfqServices.changeStatus(reqId, bodydata)
          .then((res) => {
            if (res && res.data) {
              setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
              setIsConfirmModalOpen(false);
              window.location.reload();
            } else {
              setAlertComponent({ open: true, type: "error", message: `No Data Found` });
            }
          })
          .catch((error) => {
            setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
            setIsConfirmModalOpen(false);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }

    } else {
      setAlertComponent({ open: true, type: "error", message: `Please Select Rfq Number first` });
      setIsLoading(false);
    }
  };


  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };
  const formatDate = (date) => {
    // Ensure the input is a Date object
    const parsedDate = new Date(date);

    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) {
        throw new Error("Invalid date");
    }

    const day = String(parsedDate.getDate()).padStart(2, "0");
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const year = parsedDate.getFullYear();
    return `${day}-${month}-${year}`;
};

  const handleNewDatePickerChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) { 
        const formattedFrom = formatDate(dates[0]);
        const formattedTo = formatDate(dates[1]); 
        setNewRfqValidity({
            from: formattedFrom,
            to: formattedTo,
        });

      // setNewRfqValidity({
      //   from: dateStrings[0],
      //   to: dateStrings[1]
      // });

      // const fromDate = new Date(dateStrings[0]);
      // const toDate = new Date(dateStrings[1]);
      // const differenceInTime = toDate.getTime() - fromDate.getTime();

      const differenceInDays = dates[1].diff(dates[0], 'days');

      if (differenceInDays < 30) {
        setNewValidityPeriod(`${differenceInDays} Days`);
      } else {
        const differenceInMonths = differenceInDays / 30;
        const differenceInYears = differenceInMonths / 12;
        setNewValidityPeriod(`${differenceInYears.toFixed(1)} Years`);
      }
    }
  };



  const handleDatePickerChange = (dates, dateStrings) => {
    setCurrentRfqValidity({
      from: dateStrings[0],
      to: dateStrings[1]
    });
  };

  const calculateDateDifference = () => {
    const { from, to } = currentRfqValidity;
    if (!from || !to) {
      setCurrentValidityPeriod("");
      return;
    }
    const fromDate = new Date(from);
    const toDate = new Date(to);
    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
      setCurrentValidityPeriod("");
      return;
    }

    const differenceInTime = toDate.getTime() - fromDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    if (differenceInDays < 30) {
      setCurrentValidityPeriod(`${differenceInDays.toFixed(1)} Days`);
    } else {
      const differenceInMonths = differenceInDays / 30;
      const differenceInYears = differenceInMonths / 12;
      setCurrentValidityPeriod(`${differenceInYears.toFixed(1)} Years`);
    }
  };

  const handleSubmit = () => {
    const currentDate = new Date(); // Current date
    const currentValidityStart = new Date(currentRfqValidity.from); // Current RFQ validity start date
    const currentValidityEnd = new Date(currentRfqValidity.to);
    const newValidityStart = new Date(newRfqValidity.from);
    const newValidityEnd = new Date(newRfqValidity.to);

    // Condition 1: If current validity start date <= current date, only end date can be edited 
    if (strToDate(currentValidityStart.toDateString()) <= strToDate(currentDate)) {
      if (newRfqValidity.from !== strToDate(currentValidityStart.toDateString()) ) {
        setAlertComponent({
          open: true,
          type: 'error',
          message: 'Start date cannot be changed because the current validity has already started.',
        });
        return;
      }
    }

    // Condition 2: If current validity start date > current date, both start and end date can be edited
    if (currentValidityStart > currentDate) {
      if (newValidityStart < currentDate) {
        setAlertComponent({
          open: true,
          type: 'error',
          message: 'New validity start date cannot be earlier than the current date.',
        });
        return;
      }
    }
    setIsLoading(true);
    let bodydata = {
      "rfqValidity": { from: newRfqValidity.from, to: newRfqValidity.to },
      "rfqNumber": rfqNumber,
    }
    let reqId = selectedRows[0]?._id;
    if (reqId) {
      rfqServices
        .extendValidity(reqId, bodydata)
        .then((res) => {
          if (res && res.data) {
            setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
            setOpnExtendValidtyModal(false);
            setNewValidityPeriod('');
            window.location.reload();
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          });
          setIsConfirmModalOpen(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
      // setOpnExtendValidtyModal(false);
      // setOpenExtendRfqValidtyYesModal(true);
    }
  };

  const closeExtendValidty = () => {
    setOpnExtendValidtyModal(false);
    setNewValidityPeriod('');
  }

  const handleNewRfqClose = () => {
    setOpenCreateRfqnewToggler("AgainstPackage")
    setRfqType('TWO_BID');
    setApprovalFlow('Simultaneous');
    setOpenCreateNewRfq(false);
  };

  useEffect(() => {
    if (userRole != "VENDOR") {
      getAssignEngineer();
    }
  }, []);

  const getAssignEngineer = () => {
    setIsLoading(true);
    let param = "?departments=ENGINEERING";
    rfqServices
      .getAssignEngineer(param)
      .then((res) => {
        if (res && res.data) {
          setEngineerAssignee(res?.data?.data?.assignees);
        } else {
          setAlertComponent({
            open: true,
            type: 'error',
            message: 'No Data Found',
          });
        }
      })
      .catch((error) => {
        setAlertComponent({
          open: true,
          type: 'error',
          message: `${error?.response?.data?.message}`,
        });
        setIsConfirmModalOpen(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onFieldChange = (value, secName) => {
    setEngineerAssigneeValue(value);
  };
  const [activeFilters, setActiveFilters] = useState([]);

  const handleRemoveFilter = (filterIndex, valueToRemove) => {
    // Splitting the label and values of the target filter
    const [targetLabel, targetValues] = activeFilters[filterIndex].split(':');
    const valuesArray = targetValues.split(',');

    // Removing the value to be removed
    const updatedValues = valuesArray.filter(val => val.trim() !== valueToRemove);

    let updatedFilters = [...activeFilters];

    // If no values remain, remove the entire filter
    if (updatedValues.length === 0) {
      updatedFilters = updatedFilters.filter((_, i) => i !== filterIndex);
    } else {
      // Update the target filter with remaining values
      updatedFilters[filterIndex] = `${targetLabel}:${updatedValues.join(',')}`;
    }

    setActiveFilters(updatedFilters);

    // Prepare the updated form data
    const updatedFormData = { ...filterFormData };
    if (!updatedValues.length) {
      // Remove the key entirely if no values remain
      delete updatedFormData[targetLabel];
    } else {
      // Update the form data with remaining values
      updatedFormData[targetLabel] = updatedValues.join(',');
    }

    handleFilterFormSubmit(updatedFormData);
  };
  const formatLabel = (label) => {
    const formattedLabel = label.replace(/([A-Z])/g, ' $1').trim();
    return formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
  };
  const handleFilterButtonClick = () => {
    const filterButton = document.querySelector('.filter_box');
    if (filterButton) {
      const clickableElement = filterButton.querySelector('button') || filterButton;
      clickableElement.click();
    } else {
      console.error('No element found with class filter_box');
    }
  };

  
  const [existingVendor, setexistingVendor] = useState("");
  const [existingVendorDataList, setexistingVendorDataList] = useState(""); 
  const [createVendorOpen, setCreateVendorOpen] = useState(false);
  const [selectedVendorIds, setSelectedVendorIds] = useState({});

  // const setOpenRfqExitingVenodr = () => {  

  //   //   if (statusArr.indexOf(rfqDetails?.status) >= 6){
  //   //   setexistingVendor(true);
  //   // }
    
  // }

  const setOpenRfqExitingVenodr = () => {  
    let finalStatus = selectedRows[0]?.finalStatus;
    let bidType = selectedRows[0]?.bidType;
    let commercialEvaluationStatus = selectedRows[0]?.commercialEvaluationStatus;
    let technicalEvaluationStatus = selectedRows[0]?.technicalEvaluationStatus;  
    const isPublished = statusArr.indexOf(finalStatus) >= 6; 

    const isEvaluationInProgress =
        (bidType === "One_Bid" && statusArr.indexOf(commercialEvaluationStatus) <= 9 ) ||
        (bidType === "TWO_BID" && statusArr.indexOf(technicalEvaluationStatus) <= 8); 

    const enableButtons = isPublished && !isEvaluationInProgress; 
    if (enableButtons) {
      setexistingVendor(true);
    } else {
      setexistingVendor(false);
    }
};



  const closeExitingVendorModal = () => {
    setexistingVendor(false);
  };
  const getExistingVendorRfqList = (requestPayloadParam, filterTextParam) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    rfqServices
      .getExistingVendorRfqListing(param)
      .then((res) => {
        if (res && res.data) {
          setexistingVendorDataList(res.data)
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const submitExistingVendorId = (param) => {
    const allSelectedVendorIds = Object.values(selectedVendorIds).reduce((acc, set) => {
      return acc.concat(Array.from(set));
    }, []);

    extendVendor(param, allSelectedVendorIds);
  }

  const extendVendor = (param, vendorArr) => { 
    setIsLoading(true); 
    let reqId = selectedRows[0]?._id; 
    let bodyData = {
      "isSubmitting": param, // true for Created
      "isExtendedVendor": true, //for extending vendors after submitting rfq
      //"purchaseType": rfqDetailsClone?.purchaseType,
      //"remarks": rfqDetailsClone?.remarks,
      // "rfqValidity": rfqDetailsClone?.rfqValidity,
      // "vendorIds": ["66585701a115961624b0d6ad"],
      "vendorIds": vendorArr,
      // "boqs": rfqDetailsClone?.boqs,
      // "documents": rfqDetailsClone?.documents,
    }  
    rfqServices?.updateRFQ(reqId, bodyData)
      .then((res) => {
        if (res.data.success === true) {  
          setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, });
          setTimeout(() => { 
            window.location.reload();
          }, 1000);  
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const handleCheckboxChange1 = (vendorId, isChecked, page) => {
    setSelectedVendorIds(prevState => {
      const updatedState = { ...prevState };
      if (!updatedState[page]) {
        updatedState[page] = new Set();
      }else {
        updatedState[page] = new Set(updatedState[page]);
      }
      
      if (isChecked) {
        updatedState[page].add(vendorId);
      } else {
        updatedState[page].delete(vendorId);
      }
      return updatedState;
    });
  };


  const [downloadEl1, setdownloadEl1] = React.useState(null);
  const [confirmObj, setConfirmObj] = useState({});
  const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
  useState(false);
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
      useState(false);
  const download1 = Boolean(downloadEl);
  const handleClicks1 = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses1 = () => {
    setdownloadEl(null);
  };

  const openConfirmModal = (param) => { 
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    } 
    setConfirmObj(obj);
    setOpenHeaderLevelExcelModal(true);
  }
  const closeConfirmModal1 = (param) => {
    setConfirmObj({});
    setOpenHeaderLevelExcelModal(false);
  }
  
    const downloadRFQ = () => {
      setIsLoading(true);
      let bodyData = { 
        "type": confirmObj?.id, // "line-item", header,
        ...filterFormData
      };
  
      if (!isEmptyDash(filterText)) {
        bodyData["search"] = filterText;
      } 
      let fileName = "";  
      if (confirmObj?.id == "header") {
        fileName = "Rfq_Header_Level_Excel.xlsx";
      }
      if (confirmObj?.id == "line-item") {
        fileName = "Rfq_Line_Item_Level_Excel.xlsx";
      } 
      const data = {
        url: `/v1/internal/rfqs/download`,
        bodyData: bodyData,
        method: "POST",
        fileName: fileName
      }; 
      downloadFile(data)
        .then(response => {
          if (isEmptyDash(response)) {
            setOpenHeaderLevelExcelModal(false);
            setOpenHeaderLevelSucessfullyModal(true);          
          } else {        
            setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
          }
        })
        .catch(error => {
          setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
        })
        .finally(() => {
          setIsLoading(false);
          setOpenHeaderLevelExcelModal(false);
        })
  
    }
  
  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>RFQ Listing </h5>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              <div className="rfq_creation_formtech_round1">
                <div className="rfq_creation_formtech_round1">
                <button 
                    style={{ backgroundColor:  "#274594" }} 
                    className="gate_btn_lr_creations_1 vendor_maine_contents"
                    id="basic-button"
                    aria-controls={download ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={download ? "true" : undefined}
                    onClick={handleClicks}
                  >
                    <DownloadIcon />
                    Download
                  </button>
                  <Menu
                    id="basic-menu"
                    anchorEl={downloadEl}
                    open={download}
                    onClose={handleCloses}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >

                      {(secRFQListPermission["DOWNLOAD_RFQ"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { downloadRfqDoc() }}
                      >
                        Download RFQ Documents
                      </MenuItem>}


                    <MenuItem onClick={() => openConfirmModal("header")}>
                     Header Level Excel
                    </MenuItem> 
                    <MenuItem onClick={() => openConfirmModal("line-item")}>
                      Line Item Level Excel
                    </MenuItem>
                  </Menu>



                  {(secRFQListPermission["CREATE_RFQ"]?.read == true) && <button
                    onClick={() => {
                      setOpenCreateNewRfq(true);
                    }}
                    className="gate_btn_lr_creations"
                    type="button"
                  >
                    <AddIcon />
                    Create New RFQ
                  </button>}
                  <div>
                    {UserObj?.role?.name !== 'PROJECT_MANAGER' && UserObj?.role?.name !== 'ENGINEER' && (
                      <Button
                        className="vendor_btn vendor_maine_contents"
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                      >
                        <LayersIcon />
                        Action
                      </Button>
                    )}
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {(secRFQListPermission["ROUND_2_COMPARISON"]?.read == true) && <MenuItem onClick={handleClose}>
                        <Link
                          className="extend_validity_div_reacts_asn_close"
                          style={{ color: "black", textDecoration: "none" }}
                          to="/admin/Buyer-Bidding-Initiate-Evaluation"
                        >
                          Round 2 Comparison
                        </Link>
                      </MenuItem>}
                      {(secRFQListPermission["INITIATE_ROUND_2"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        onClick={handleClose}
                      >
                        {" "}
                        <Link
                          className="extend_validity_div_reacts_asn_close"
                          style={{ color: "black", textDecoration: "none" }}
                          to="/admin/Buyer-Bidding-Commercial-Comparison"
                        >
                          Initiate Round 2{" "}
                        </Link>{" "}
                      </MenuItem>}

                      {(secRFQListPermission["EXTEND_VALIDITY"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={setOpnExtendValidtyModal}
                        onClick={() => { changeStatusConfirmation('Extend') }}
                      >
                        Reschedule Validity
                      </MenuItem>}

                      {/* {<MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={setOpnExtendValidtyModal}
                        onClick={() => { changeStatusConfirmation('Extend_vendor') }}
                      >
                        Extend Vendor
                      </MenuItem>} */}


                      {(secRFQListPermission["PUBLISH_RFQ"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        onClick={() => { changeStatusConfirmation('Publish') }}
                      >
                        Publish RFQ
                      </MenuItem>}

                      {(secRFQListPermission["PARTICIPATE"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { changeStatusConfirmation('Participate') }}
                      >
                        Participate
                      </MenuItem>}

                      {(secRFQListPermission["REJECT"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { changeStatusConfirmation('Reject') }}
                      >
                        Reject
                      </MenuItem>}
                      {(secRFQListPermission["APPROVE"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { changeStatusConfirmation('ApproveAndPublish') }}
                      >
                        Approve & Publish RFQ
                      </MenuItem>}
                      {/* {(secRFQListPermission["HOLD"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { changeStatusConfirmation('Hold') }}
                      >
                        Hold
                      </MenuItem>} */}
                      {(secRFQListPermission["APPROVE"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { changeStatusConfirmation('Approve') }}
                      >
                        Approve
                      </MenuItem>}
                      {userRole === "BUYER" ? (
                      <MenuItem  onClick={() => { changeStatusConfirmation('request_approval') }}>Request for Approval</MenuItem>
                    ) : null }
                      {/* {userRole === "MANAGER" ? (
                        
                      <MenuItem  onClick={() => { navigateUrl('/admin/nfa-approval') }}>Approve Request</MenuItem>
                    ) : null } */}

                      {(secRFQListPermission["DOWNLOAD_RFQ"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { downloadRfqDoc() }}
                      >
                        Download
                      </MenuItem>}
                      {(secRFQListPermission["CLOSE_RFQ"]?.read == true) && <MenuItem
                        className="extend_validity_div_reacts_asn_close"
                        // onClick={handleClose}
                        onClick={() => { changeStatusConfirmation('Cancel') }}
                      >
                        Close RFQ
                      </MenuItem>}
                    </Menu>
                    
                  </div>
                  
                </div>
                <div style={{ marginTop: "-8px" }}>
                  <div className="lets_filter_vendorlist_body_detail btn row_filterrbtnvendor_box">
                    <FilterAltOutlinedIcon />
                    <Filter uniqueName="RFQ" formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                  </div>
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isLoading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                </div>
               
              </div>
              
            </div>
            <div>
              <ul className="project_listing_gap_bcfe_react">
                {activeFilters.slice(0, 3).map((filter, index) => {
                  const [label, value] = filter.split(':');
                  const valuesArray = value.split(',');
                  return (
                    <li key={index} className="project_listing_gap_bcfe_react_one">
                      <strong>{formatLabel(label)}:</strong>
                      {valuesArray.map((val, i) => (
                        <span key={i} className="filter_sel">
                          {val}
                          <button
                            type="button"
                            className="btn-close"
                            style={{ fontSize: "10px", marginLeft: "5px" }}
                            onClick={() => handleRemoveFilter(index, val)}
                          ></button>
                        </span>
                      ))}
                    </li>
                  );
                })}
                {activeFilters.length > 3 && (
                  <button className="btn btn-outline-info" onClick={handleFilterButtonClick}><AddIcon className="add_icons" />{activeFilters.length}</button>
                )}
              </ul>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div style={{ width: "100%", overflow: "hidden" }}
                  className="listing_main listing_main_dragdropcontext_body listingmain"
                  // style={{ overflowX: "scroll", marginTop: "-37px" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          {/* <input type="checkbox" /> */}
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className={`vendor_tabels ${column.isFiltered ? 'highlighted_column' : ''}`}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead> 
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {rfqlisting?.rfqs.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}
                      {rfqlisting.rfqs.length > 0 && <>
                        {rfqlisting?.rfqs?.map((row, rowIndex) => (

                          < tr key={rowIndex} className="maine_tr_vendor" >
                            <td>
                            <input
                              type="checkbox"
                              checked={isChecked(row._id)}
                              onChange={(e) => handleCheckboxChange(e, row)}
                              key={`checkbox-${rowIndex}`}
                              disabled={
                                row.participationStatus === "Submitted" ||
                                row.participationStatus === "Rejected" ||
                                // row.finalStatus === "Round 2 Completed" ||
                                (UserObj?.role?.name === 'VENDOR' && row.finalStatus === "RFQ Expired")
                              }
                            />
                            </td>
                            {
                              columns.map((column, index) => (<>

                                {(column.id == "rfqNumber") ? <td>
                                  <p
                                    className="list-details-para"
                                    // style={{ textDecoration: "none" }}
                                    // to={`/admin/Buyer-Bidding-Rfq-Creaction-Form/${row?._id}`}
                                    onClick={() => redirectToDetails(row?._id)}
                                  >
                                    {row[column.id]}
                                  </p>
                                </td> : column.id === "rfqValidity.from" ? (
                                  <td>{row.rfqValidity?.from ? strToDate(row.rfqValidity.from) : "N/A"}</td>
                                ) : column.id === "rfqValidity.to" ? (
                                  <td>{row.rfqValidity?.to ? strToDate(row.rfqValidity.to) : "N/A"}</td>
                                ) : column.id === "invitationDate" ? (
                                  <td>{row.invitationDate ? strToDate(row?.invitationDate) : "N/A"}</td>
                                ) : column.id === "lastUpdatedOn" ? (
                                  <td>{row.lastUpdatedOn ? strToDate(row.lastUpdatedOn) : "N/A"}</td>
                                ) :
                                column.id === "nfa" ? (
                                  <td> 
                                    {!isEmptyDash(row.nfaId) && (
                                       <Link
                                        className="solutions_block_body"
                                        style={{ textDecoration: "none" }}
                                        to={`/admin/nfa-approval/${row.nfaId}`}
                                      ><button className="btn btn-success">View</button>
                                      </Link>
                                    )}
                                   
                                
                                </td>
                                ) : 
                                
                                column.id === "createdAt" ? (
                                  <td>{row.createdAt ? strToDate(row.createdAt) : "N/A"}</td>
                                ):
                                  (row[column.id] === "TWO_BID") ? <td>Two Bid</td> :
                                    (row[column.id] === "ONE_BID") ? <td>One Bid</td> :
                                    <td key={index} >
                                    <Tooltip title={row[column.id] || "N/A"}>
                                    {row[column.id] ? trimString(row[column.id], 20) : "N/A"}
                                    </Tooltip>
                                  </td>
                                }
                              </>
                              ))
                            }
                          </tr>
                        ))}
                      </>}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {rfqlisting?.rfqs.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(rfqlisting?.pageSize) * Number(rfqlisting?.currentPage - 1) + 1} to ${Number(rfqlisting?.pageSize) * Number(rfqlisting?.currentPage - 1) + Number(rfqlisting?.rfqs.length)} of ${rfqlisting?.totalItems}`}
                </span>
              </div>
              <Stack spacing={2}>
                {/* <div className="listing_project_block">
                  <input
                    className="form-control form-hasw"
                    type="text"
                    fdprocessedid="u2nmq"
                    value={inputPage}
                    onChange={handleInputChange}
                    onKeyDown={handleInputSubmit}
                    style={{ width: "15%" }}
                  />
                </div>
                <Pagination
                  count={rfqlisting?.totalPages}
                  page={rfqlisting?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                /> */}
                <Pagination
                  count={rfqlisting?.totalPages}
                  page={rfqlisting?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === rfqlisting?.currentPage) {
                      return (
                        <input
                          className="form-control"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                          style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}
                />
              </Stack>
            </div>
          </>}
          {/* Create New RFQ Modal */}
          <Modal
            open={opencreatenewrfq}
            onClose={() => handleNewRfqClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5 create_rfq" id="exampleModalLabel">
                  Create New RFQ
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => handleNewRfqClose()}
                ></button>
              </div>
              <div class="modal-body">
                <div class="header_lineitems">
                  <span onClick={() => setOpenCreateRfqnewToggler("AgainstPackage")} class={opencreaterfqnewtoggler === "AgainstPackage" ? "line-tb" : "header-tb"}>Against Package</span>
                  <span onClick={() => setOpenCreateRfqnewToggler("WithoutPackage")} class={opencreaterfqnewtoggler === "WithoutPackage" ? "line-tb" : "header-tb"}>Without Package</span>
                </div>
                <div className="lets_n_vendor_technical_comercial_staus_listing">
                  <p>One Bid (Only Commercial)</p>
                  <Switch
                    checked={rfqType === 'TWO_BID'}
                    onChange={handleRfqTypeChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                  <p>Two Bid (Comm+Tech)</p>
                </div>

                {(opencreaterfqnewtoggler === "WithoutPackage" && rfqType === 'TWO_BID') &&
                <>
                  <div className="lets_package_number_listing">
                    <label className="package_number_body_vendor_portal_block">
                      Assign Engineer
                    </label>
                    <select
                      id="assignEngineer"
                      className="form-select select_react_form_vendorlist"
                      aria-label="Default select example"
                      fdprocessedid="2t62w"
                      onChange={(e) => onFieldChange(e.target.value)}
                    >
                      <option value="">Select Assign Engineer</option>
                      {engineerAssignee?.map((data, index) => (
                        <option key={index} value={data._id}>{data.name}</option>
                      ))}
                    </select>
                  </div>
                 
                </>
                  
                }
               {(opencreaterfqnewtoggler === "WithoutPackage" ) &&
                <div class="lets_package_number_listing">
                  <label className="package_number_body_vendor_portal_block">
                    Project Code 
                  </label> 
                      <CustomSearchDropdown
                        listingArrName="projects"
                        onSearchSelectChange={onSearchSelectChange}
                        promiseRequest={projectServices?.getProjectListing}
                        additionalData={{
                          lableKeyName1: "projectCode",
                          lableKeyName2: "projectName",
                          valueKeyName: "_id",
                        }}
                        isDisable={false}
                        defaultValue={selectedProjectCode}
                      /> 
                </div>
                  }
                {rfqType === 'TWO_BID' &&
                  <div className="lets_n_vendor_technical_comercial_staus_listing">
                    <p>Linear</p>
                    <Switch
                      checked={ApprovalFlow === 'Simultaneous'}
                      onChange={handleRfqApprovalFlow}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                    <p>Simultaneous </p>
                  </div>
                }
                {opencreaterfqnewtoggler === "AgainstPackage" &&
                  <div class="lets_package_number_listing">
                    <label className="package_number_body_vendor_portal_block">
                      Package No.
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      fdprocessedid="8achb"
                      value={packagecodesrequested}
                      onChange={(e) => setPackageCodesRequested(e.target.value)}
                    />
                  </div>}

              </div>
              <div class="closebtn_submit_block_btn">
                <button
                  type="button"
                  class="btn clear_btn_status_block_lists"
                  fdprocessedid="wshspp"
                  onClick={() => handleNewRfqClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-success save_next_btns"
                  fdprocessedid="37eo4"
                  onClick={submitRFQ}

                >
                  {/* <Link
                    style={{ color: "white", textDecoration: "none" }}
                    to="/admin/Buyer-Bidding-Rfq-Creaction-Form"
                  >
                    Submit
                  </Link> */}
                  Submit
                </button>
              </div>
            </Box>
          </Modal>
          {/*Extend Validty RFQ Listing */}

          {/*Extend RFQ Validty Yes */}

          <Modal
            open={openextendrfqvalidtyyesmodal}
            onClose={() => setOpenExtendRfqValidtyYesModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenExtendRfqValidtyYesModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <from>
                  <div class="approvel_btn_successfully">
                    <h3 class="evaluation_block">Extend RFQ validity</h3>
                    <p>
                      This action will change the RFQ validity.
                      <br /> Do you want to continue?
                    </p>
                    <p></p>
                    <div class="lets_no_btn_danger_yes_technical_project">
                      <button
                        type="button"
                        class="btn btn btn-danger"
                        onClick={() => {
                          setOpenExtendRfqValidtyYesModal(false);
                        }}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        class="btn btn-success"
                        onClick={() => {
                          setOpenExtendRfqValidtyYesModal(false);
                          setOpenValidtyExtendSuccessfully(true);
                        }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>

          {/** Extendor Vendor */} 
          <Modal
            open={showExtendVendor}
            onClose={() => setShowExtendVendor(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Extend Vendor</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"   
                  onClick={() => setShowExtendVendor(false)}
                ></button>
              </div> 
              <div class="modal-bodys"> 
                <div class="create_listing_project_divs_react_taxsolutions_div_listwq">
                <button
                  onClick={() => {setOpenRfqExitingVenodr() }}
                  className="gate_btn_lr_creations"
                  type="button"
                >
                  Choose Existing Vendor
                </button>
                <button
                  onClick={() => {
                    setCreateVendorOpen(true);
                  }}
                  className="gate_btn_lr_creationrfq"
                  type="button"
                >
                  <PersonIcon />
                  Invite New Vendor
                </button>
              </div> 
              </div>
            </Box>
          </Modal>

          {/** Reject Modal */}

          <Modal
            open={showRejctModal}
            onClose={() => setShowRejectModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Reject RFQ</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setShowRejectModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div>
                  <img src={checkImage} alt="" />
                </div> 
                <p>
                You have rejected the RFQ successfully. Buyer will be notified & you will not be able to participate in this bidding.
                </p>
                <button
                  href="Listingrfqbuyerbidding.html"
                  type="button"
                  class="btn btn-success"
                  onClick={() => setShowRejectModal(false)}
                >
                  Done
                </button>
              </div>
            </Box>
          </Modal>

          {/* RFQ Listing Extend Validty Sucessfully */}
          <Modal
            open={openvalidtyextendsuccessfully}
            onClose={() => setOpenValidtyExtendSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenValidtyExtendSuccessfully(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <div>
                  <img src={checkImage} alt="" />
                </div>
                <h3 class="evaluation_block">Extend RFQ validity</h3>
                <p>
                  Congratulations! RFQ Validity has been extended <br />
                  successfully
                </p>
                <button
                  href="Listingrfqbuyerbidding.html"
                  type="button"
                  class="btn btn-success"
                  onClick={() => setOpenValidtyExtendSuccessfully(false)}
                >
                  Done
                </button>
              </div>
            </Box>
          </Modal>


          {/* Approve RFQ Publish in RFQ Listing */}
          <Modal
            open={openapproverfqpublishmodal}
            onClose={() => setOpenApproveRfqPublishModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenApproveRfqPublishModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <h3 class="evaluation_block">Approve & Publish RFQ</h3>
                <p>
                  On Approval of this RFQ, the bidding process will be initiated
                  <br />& invite will be published to respective Vendors
                </p>
                <p className="lets_selected_round_detail_invited">
                  Do you want to continue?
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={() => {
                      setOpenApproveRfqPublishModal(false);
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenApproveRfqPublishModal(false);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          <Modal
              open={openheaderlevelexcelmodal}
              onClose={closeConfirmModal1}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelExcelModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download
                    <br /> {confirmObj?.text}
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={downloadRFQ}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={closeConfirmModal1}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
            <Modal
              open={openheaderlevelsucessfullymodal}
              onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">   Selected <b>{confirmObj?.text}</b> file has been
                  <br /> downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHeaderLevelSucessfullyModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
        </div>
      </div>
      
      <ExitingVendor
          existingVendor={existingVendor}
          closeExitingVendorRFQModal={closeExitingVendorModal}
          getExistingVendorRfqList={getExistingVendorRfqList}
          onCheckboxChange={handleCheckboxChange1}
          vendorList={existingVendorDataList}
          submitExistingVendorId={submitExistingVendorId}
          selectedVendorIds={selectedVendorIds}
          //rfqVendorsIds={rfqDetails?.rfqVendors}
        />


      <RfqExtendValidaity
        setOpnExtendValidtyModal={setOpnExtendValidtyModal}
        opnextendvalidtymodal={opnextendvalidtymodal}
        rfqNumber={rfqNumber}
        currentRfqValidity={currentRfqValidity}
        handleNewDatePickerChange={handleNewDatePickerChange}
        newValidityPeriod={newValidityPeriod}
        closeExtendValidty={closeExtendValidty}
        handleSubmit={handleSubmit}
        currentValidityPeriod={currentValidityPeriod}
      />

      <ConfirmModal
        isConfirmModalOpen={isConfirmModalOpen}
        closeConfirmModal={closeConfirmModal}
        successConfirmModal={successConfirmModal}
        modalMsg="Do you want to continue?"
        status={status}
      />
      <NfaApprovalModal
         setOpenNfaApprovelModal={setOpenNfaApprovelModal}
         opennfaapprovelmodal={opennfaapprovelmodal}
         rfqId = {(selectedRows[0] ) ? selectedRows[0]: ''}
      />
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClosess}
      />
    </>
  );
}

export default ListingRFQ;
